import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.cart = ReducerFuncs }

export {
  Routes,
  Reducers
}
